import { dateFormat } from './date';

import moment from 'moment'

export default function (Vue) {
  // 保留两位小数
  Vue.filter('formateNumRound', function (value) {
    let val = Number(value).toFixed(2)
    return val
  })
  // 用户类型
  Vue.filter("formatAdminType", function (value) {
    let val = '';
    switch (value) {
      case '1':
        val = '管理员'
        break;
      case '2':
        val = '审核员'
        break;
      case '3':
        val = '编辑'
        break;
      default:
        val = '';
        break;
    }
    return val;
  });

  Vue.filter("formatEnlistType", function (value) {
    let val = '';
    switch (value) {
      case '1':
        val = '测评'
        break;
      case '2':
        val = "活动"
        break;
      case '3':
        val = '课程'
        break;
      default :
        val = value+'暂不支持此类型';
        break;
    }
    return val;
  });

  //格式化YN
  Vue.filter("formatYN", function (value) {
    let val = '--';
    if (value === 'Y') {
      val = '是'
    }
    if (value === 'N') {
      val = '否'
    }
    return val;
  });

  // 状态值
  Vue.filter("formatAudit", function (value) {
    let val = '';
    switch (value) {
      case 'S':
        val = '未提交'
        break;
      case 'E':
        val = '已提交'
        break;
      case 'Y':
        val = '审核通过'
        break;
      case 'N':
        val = '审核未通过'
        break;
      case 'R':
        val = '成绩已上传'
        break;
      case 'C':
        val = '证书已上传'
        break;
      case null:
        val = '状态未知'
    }
    return val;
  });

  // 是否为合作机构
  Vue.filter("formatCooperate", function (value) {
    let val = '';
    switch (value) {
      case 'Y':
        val = '是'
        break;
      case 'N':
        val = '否'
        break;
      case null:
        val = '状态未知'
    }
    return val;
  });

  // 性别
  Vue.filter("formatGender", function (value) {
    let val = ' ';
    switch (value) {
      case 'M':
        val = '男'
        break;
      case 'F':
        val = '女'
        break;
    }
    return val;
  });

  // 性别
  Vue.filter("formatEducation", function (value) {
    let val = '';
    switch (value) {
      case '0':
        val = '无学历'
        break;
      case '1':
        val = '小学'
        break;
      case '2':
        val = '初中'
        break;
      case '3':
        val = '高中'
        break;
      case '4':
        val = '大专'
        break;
      case '5':
        val = '本科'
        break;
      case '6':
        val = '硕士'
        break;
      case '7':
        val = '博士'
        break;
    }
    return val;
  });

  Vue.filter("formatTeacherType", function(value) {
    let val = '未定义类型';
    switch (value) {
      case "1":
        val = '专家'
        break;
      case "2":
        val = '机构授课老师'
        break;
    }
    return val;
  });

  // 级别
  Vue.filter("formatRank", function (value) {
    let val = '未填写';
    switch (Number(value)) {
      case 1:
        val = '初级'
        break;
      case 5:
        val = '中级'
        break;
      case 10:
        val = '高级'
        break;
    }
    return val;
  });

  // 用户管理状态值
  Vue.filter("formatState", function (value) {
    let val = '';
    switch (value) {
      case 'A':
        val = '激活'
        break;
      case 'F':
        val = '冻结'
        break;
    }
    return val;
  });

  // 是否导出
  Vue.filter("formatDown", function (value) {
    let val = '';
    switch (Number(value)) {
      case 0:
        val = '否'
        break;
      case 1:
        val = '是'
        break;
    }
    return val;
  });

  // 审核状态值
  Vue.filter("formatAudit", function (value) {
    let val = '未审核';
    switch (value) {
      case '1':
        val = '通过'
        break;
      case '2':
        val = '未通过'
        break;
    }
    return val;
  });


  Vue.filter('formatScore', function (value) {
    if(value == null || value < 1) {
      return ''
    } else if (value >= 90) {
      return '优秀';
    } else if (value >= 70) {
      return '良好'
    } else if (value >= 60) {
      return '合格';
    } else if (value > 1){
      return '不合格';
    }
  });

  // 评审意见
  Vue.filter('formatOpinion', function (value) {
    let val = '' 
    switch (Number(value)) {
      case 1:
        val = '优秀'
        break;
      case 2:
        val = '良好'
        break;
      case 3:
        val = '合格'
        break;
      case 4:
        val = '不合格'
        break;
    
      default:
        break;
    }
  return val
  });

  //  综合评价
  Vue.filter('formatEvaluate', function (value) {
    let val = '' 
    switch (Number(value)) {
      case 1:
        val = '很好'
        break;
      case 2:
        val = '尚好'
        break;
      case 3:
        val = '尚可'
        break;
      case 4:
        val = '较差'
        break;
    
      default:
        break;
    }
  return val
  });

  // 日期转换
  Vue.filter('formatDate', function (msg, pattern = "YYYY-MM-DD") {
    return moment(msg).format(pattern)
  });
  // 日期转换
  Vue.filter('formatDateSlash', function (msg, pattern = "YYYY/MM/DD") {
    return moment(msg).format(pattern)
  });

  Vue.filter('formatDateTime', function (msg, pattern = "YYYY-MM-DD HH:mm") {
    return moment(msg).format(pattern)
  });

  // 时/分/秒 转换
  Vue.filter('formatTime', function (s) {
    let HH = (Math.floor(s/3600) + '').padStart('2','0');
    let mm = (Math.floor(s/60 - HH*60) + '').padStart('2','0');
    let ss = (Math.floor(s - 60*mm - HH*3600) + '').padStart('2','0');
    return `${HH}:${mm}:${ss}`
  });

  // 文件类型
  Vue.filter("formatFile", function (value) {
    let val = "";
    switch (value) {
      case '1':
        val = 'Excel'
        break;
      case '2':
        val = 'Word'
        break;
      case '3':
        val = 'PDF'
        break;
    };
    return val;
  });

  // 访问权限
  Vue.filter("formatAccess", function(value) {
    let val = '';
    switch (value) {
      case 'A':
        val = '所有人'
        break;
      case 'F':
        val = '不可以访问'
        break;
      case 'P':
        val = '可以访问'
        break;
    }
    return val;
  });

  // 等级显示
  Vue.filter("formatLevel", function(level,evaluateType) {
    let val = '';
    if (evaluateType==1){
      switch (level) {
        case 1:
          val = '1级'
          break;
        case 2:
          val = '2级'
          break;
        case 3:
          val = '3级'
          break;
        case 4:
          val = '4级'
          break;
        case 5:
          val = '5级'
          break;
        case 6:
          val = '6级'
          break;
        case 7:
          val = '7级'
          break;
        case 8:
          val = '8级'
          break;
        case 9:
          val = '9级'
          break;
        case 10:
          val = '10级'
          break;
      }
    }else {
      switch (level) {
        case 1:
          val = '初级'
          break;
        case 2:
          val = '中级'
          break;
        case 3:
          val = '高级'
          break;
      }
    }
    return val;
  });

  // 日期
  Vue.filter('FormatDate', function (date, fmt) {
    return dateFormat(date, fmt)
  })
}


// WEBPACK FOOTER //
// ./src/util/filter.js